import { useEffect, useState } from 'react';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { DetailItem } from '@recargas-dominicanas/core/components';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { type IPendingTransaction } from '@recargas-dominicanas/core/types';
import { BankAccountStore } from '../../../../store/bankAccountStore';
import { Modal } from '../../../../components/modal/modal.component';
import { EditField } from '../edit-field/edit-field.component';
import { style } from './register-pending-profit-withdrawal-modal.module.css';

interface Props {
  open: boolean;
  bankAccountId: number;
  pendingTransaction: IPendingTransaction;
  onClose: () => void;
}

export function RegisterPendingProfitWithdrawalModal(props: Props) {

  const {
    open,
    bankAccountId,
    pendingTransaction,
    onClose
  } = props;

  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState<string>();
  const [description, setDescription] = useState('');

  useEffect(() => {
    setDescription(pendingTransaction.description || '');
  }, [open, pendingTransaction.description]);

  async function handleRegister() {
    
    try {

      setDisabled(true);
      setError(undefined);

      const customDescription = description && description !== pendingTransaction.description ? description : undefined;
      
      await BankAccountApi.registerPendingProfitWithdrawal(bankAccountId, pendingTransaction.id, customDescription);
      
      BankAccountStore.fetchById(bankAccountId);
      BankAccountStore.fetchPendingTransactions(bankAccountId, 1, 25);

      handleClose();

    } catch {

      setDisabled(false);
      setError('Error registrando retiro');
    }
  }

  function handleClose() {
    onClose();
    setDisabled(false);
    setError(undefined);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Registrar retiro como gasto'
      error={error}
      secondaryButton='Registrar'
      disabledSecondaryButton={disabled}
      onClose={handleClose}
      onSecondaryClick={handleRegister}>
      <DetailItem
        style={style.detailItem}
        title='Monto'
        color='green'
        weight='medium'
        text={formatCurrency(pendingTransaction.balance)}/>      
      <DetailItem
        style={style.detailItem}
        title='Fecha'
        text={formatDate(pendingTransaction.date)}/>
      <DetailItem
        style={style.detailItem}
        title='Fecha de creación'
        text={formatDate(pendingTransaction.creationDate)}/>      
      {pendingTransaction.reference &&
        <DetailItem
          style={style.detailItem}
          title='Referencia'
          text={pendingTransaction.reference}/>      
      }      
      <EditField
        title='Descripción'
        placeholder='Agregar descripción'
        value={description}
        onChange={value => setDescription(value)}/>
    </Modal>
  );
}
